import { z } from "zod";
import { regionSchema } from "./region";

export const provinceSchema = z.object({
	id: z.string().optional(),
	name: z.string().nullable().optional(),
	code: z.string().nullable().optional(),
	region_code: z.string().optional(),
	region: regionSchema.optional(),
	created_at: z.string().optional(),
	updated_at: z.string().optional(),
});

export type Province = z.infer<typeof provinceSchema>;
